import {
  Controller,
  ControllerProps,
  ControllerRenderProps,
  FieldErrors,
  Path,
  useFormContext,
} from "react-hook-form";
import { Box, Input, Stack, Text } from "@chakra-ui/react";
import { TicketTypeValues } from "./schema";

function InputWithLabel<T = TicketTypeValues>({
  name,
  label,
  placeholder,
  children = <></>,
  required,
  renderInput,
  //@ts-ignore
  controllerProps = {},
  //@ts-ignore
  inputProps = {},
  disabled = false,
  ...props
}: {
  name: Path<T>;
  label: string;
  required?: boolean;
  renderInput?: (props: {
    field: ControllerRenderProps<T>;
    errors: FieldErrors<T>;
  }) => React.ReactElement;
  placeholder?: string;
  children?: React.ReactNode;
  controllerProps?: Partial<ControllerProps<T>>;
  inputProps?: Partial<any>;
  disabled?: boolean;
}) {
  const {
    control,
    formState: { errors },
  } = useFormContext<T>();

  const _renderInput = renderInput
    ? renderInput
    : ({
        field,
        errors,
      }: {
        field: ControllerRenderProps<T>;
        errors: FieldErrors<T>;
      }) => {
        return (
          <Input
            placeholder={placeholder}
            isInvalid={!!errors[name as string]}
            //@ts-ignore
            value={field.value}
            {...field}
            {...inputProps}
            disabled={field.disabled}
          />
        );
      };

  return (
    <Stack w="full" {...props}>
      <Text fontWeight={"medium"}>
        {label}
        {required ? " (*)" : ""}
      </Text>
      <Controller<T>
        name={name}
        control={control}
        defaultValue={undefined}
        render={({ field }) => _renderInput({ field, errors })}
        {...controllerProps}
      />
      {children}
      <Box h={4}>
        {errors[name as string] ? (
          <Text fontSize={"sm"} color="red.300">
            {`${errors[name].message}`}
          </Text>
        ) : null}
      </Box>
    </Stack>
  );
}

export default InputWithLabel;
